import '../SettingsPage.scss';
import './ImportETicketsPage.scss';
import { Button, Card, Dropdown, Icon, Textarea } from '@design-system/index';
import { ProductsCatalogLine } from '@icons';
import { useImportETicketsPageVM } from './useImportETicketsPageVM';
import { Formik } from 'formik';
import { ETicketToImport } from '@services/product/eTicket/e-ticket.types';

export default function ETicketsPage() {
    const {
        eticketTypes,
        importETicket,
        isImportETicketLoading,
        isGetETicketTypesLoading
    } = useImportETicketsPageVM();

    return (
        <>
            <div className="settings-tabs-content import-etickets-container">
            <Card
                isLoading={isImportETicketLoading || isGetETicketTypesLoading}
                headerType="very-light"
                headerTitle={"Import des e-billets"}
                headerIcon={<Icon icon={<ProductsCatalogLine />} size={20} color="primary" />}
            >
            <Formik
                    initialValues={{
                        eticketType: undefined,
                        labels: '',
                        codes: '',
                        pins: '',
                        expirations: ''
                    }}
                    onSubmit={async (values: ETicketToImport, { resetForm }: { resetForm: () => void }) => {
                        await importETicket(values);
                        resetForm();
                    }}
                >
                    {({ values, handleChange, handleSubmit, setFieldValue, isSubmitting }) => (
                        <form className="form" onSubmit={handleSubmit}>
                            <Dropdown
                                name="eticketType"
                                label="Type de E-billet"
                                value={values.eticketType}
                                required
                                onOptionChange={(option) => {
                                    setFieldValue('eticketType', option);
                                }}
                                options={eticketTypes.map((eticketType) => ({
                                    label: eticketType.label,
                                    id: eticketType.id
                                }))}
                            />
                            <div className="form-line-flex">
                                <div className="form-line">
                                    <Textarea
                                        name="labels"
                                        label="Libellés"
                                        height={500}
                                        value={values.labels}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-line">
                                    <Textarea
                                        name="codes"
                                        label="Codes"
                                        height={500}
                                        value={values.codes}
                                        required
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-line">
                                    <Textarea
                                        name="pins"
                                        label="Pins"
                                        height={500}
                                        value={values.pins}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-line">
                                    <Textarea
                                        name="expirations"
                                        label="Expirations"
                                        height={500}
                                        value={values.expirations}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                                
                            <div className="action-buttons">
                                <Button type="submit" disabled={isSubmitting} variant="primary">
                                    Importer les e-billets
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik> 
            </Card>
            </div>
        </>
    );
}
